var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Select',{attrs:{"multiple":_vm.multiple,"filterable":"","placeholder":"请选择合集","clearable":""},on:{"on-change":_vm.change},model:{value:(_vm.sel),callback:function ($$v) {_vm.sel=$$v},expression:"sel"}},_vm._l((_vm.list),function(item){return _c('Option',{attrs:{"label":item.name,"value":item.id}})}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c360584","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ziliao/common/HejiSelect.vue
// module id = null
// module chunks = 